import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import CourseLayout from "./CourseLayout";
import ArticleReader, { Lesson } from "./ArticleReader";
import apiService from "../../../../service/Api";

const DUMMY_LESSONS: Lesson[] = [
  {
    id: 9991,
    content_type: "article",
    title: "Practice Assignment (Coming Soon)",
    description: "Hands-on practice content will appear here",
    duration: "—",
  },
  {
    id: 9992,
    content_type: "audio",
    title: "Bonus Tips (Coming Soon)",
    description: "Extra learning material",
    duration: "—",
  },
];

export default function CourseView() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [lessons, setLessons] = useState<Lesson[]>([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const fetchCourse = async () => {
      try {
        const response = await apiService.get<{
          id: number;
          content_type?: string;
          title?: string;
          description?: string;
          content_text?: string | null;
          youtube_url?: string | null;
        }>(`/api/lms/courses/${id}/`);
        const course = response.data;

        const allowedTypes: Lesson["content_type"][] = [
          "article",
          "audio",
          "video",
          "course",
        ];
        const contentType = allowedTypes.includes(
          course.content_type as Lesson["content_type"]
        )
          ? (course.content_type as Lesson["content_type"])
          : "video";

        const courseAsLesson: Lesson = {
          id: course.id,
          content_type: contentType,
          title: course.title || "Untitled Course",
          description: course.description || "",
          content_text: course.content_text || null,
          duration: "10 min",
          youtube_url: course.youtube_url || undefined,
        };

        setLessons([courseAsLesson, ...DUMMY_LESSONS]);
      } catch (err) {
        console.error("Failed to fetch course:", err);
      }
    };

    fetchCourse();
  }, [id]);

  if (!lessons.length) return <div>Loading course…</div>;

  const currentLesson = lessons[currentIndex];
  const nextLesson = lessons[currentIndex + 1] || null;

  const getEmbedUrl = (url?: string | null) => {
    if (!url) return "";
    const youtubeMatch = url.match(/(?:v=|\/)([a-zA-Z0-9_-]{11})/);
    if (youtubeMatch) return `https://www.youtube.com/embed/${youtubeMatch[1]}`;
    if (url.includes("vimeo.com")) {
      const vimeoMatch = url.match(/vimeo\.com\/(\d+)/);
      if (vimeoMatch) return `https://player.vimeo.com/video/${vimeoMatch[1]}`;
    }
    return url;
  };

  return (
    <CourseLayout
      currentLesson={currentLesson}
      currentLessonIndex={currentIndex}
      totalLessons={lessons.length}
      lessons={lessons}
      progress={((currentIndex + 1) / lessons.length) * 100}
      nextLesson={nextLesson}
      onNext={() => setCurrentIndex((i) => Math.min(i + 1, lessons.length - 1))}
      onPrevious={() => setCurrentIndex((i) => Math.max(i - 1, 0))}
      onSelectLesson={(index) => setCurrentIndex(index)}
      onBack={() => navigate("/courses")}
    >
      {(currentLesson.content_type === "video" && currentLesson.youtube_url) ||
      currentLesson.content_type === "course" ? (
        <iframe
          src={getEmbedUrl(currentLesson.youtube_url)}
          width="100%"
          height="400"
          style={{ borderRadius: 12 }}
          allowFullScreen
          title={currentLesson.title || "Course video"}
        />
      ) : currentLesson.content_type === "article" ? (
        <ArticleReader lesson={currentLesson} />
      ) : (
        <div
          style={{
            height: 300,
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 12,
            background: "#111",
          }}
        >
          {currentLesson.title}
        </div>
      )}
    </CourseLayout>
  );
}
